import {Component} from 'react'
import {AiFillHome} from 'react-icons/ai'
import {BsBriefcaseFill} from 'react-icons/bs'
import {IoIosLogOut} from 'react-icons/io'
import Cookies from 'js-cookie'
import {Link, withRouter} from 'react-router-dom'
import './index.css'

class Headers extends Component {
  onClickLogout = () => {
    const {history} = this.props
    Cookies.remove('jwt_token')
    history.replace('/login')
  }

  render() {
    return (
      <div className="nav-bg-container">
        <nav className="nav-container">
          <Link to="/">
            <img
              alt="website logo"
              className="jobby-logo"
              src="https://assets.ccbp.in/frontend/react-js/logo-img.png"
            />
          </Link>
          <ul className="link-container">
            <Link to="/" className="nav-link">
              <li>Home</li>
            </Link>
            <Link to="/jobs" className="nav-link">
              <li>Jobs</li>
            </Link>
          </ul>
          <button
            type="button"
            className="logout-btn"
            onClick={this.onClickLogout}
          >
            Logout
          </button>
          <ul className="small-devies-nav-container">
            <Link to="/" className="nav-icon">
              <li>
                <AiFillHome size="30" color="#f8fafc" />
              </li>
            </Link>
            <Link to="/jobs" className="nav-icon">
              <li>
                <BsBriefcaseFill size="30" color="#f8fafc" />
              </li>
            </Link>
            <li className="nav-icon">
              <button
                className="logout-icon"
                type="button"
                onClick={this.onClickLogout}
              >
                <IoIosLogOut size="30" color="#f8fafc" />
              </button>
            </li>
          </ul>
        </nav>
      </div>
    )
  }
}
export default withRouter(Headers)
